import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import { galleryImages } from '../mock';
import BookingWalkthrough from './BookingWalkthrough';
import VideoThumbnail from './VideoThumbnail';

const GalleryPage = () => {
  const navigate = useNavigate();

  // Meta Pixel ViewContent tracking for Gallery page
  useEffect(() => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'ViewContent', {
        content_type: 'product',
        content_name: 'Gallery Page - Pro-Wash Mobile Detailing Work',
        content_category: 'Mobile Car Detailing Gallery',
        value: 299,
        currency: 'CAD'
      });
    }
  }, []);

  const handleBackHome = () => {
    navigate('/');
  };

  // Get gallery images (first 12 items for the page)
  const displayImages = galleryImages.slice(0, 12);

  return (
    <>
      <main className="bg-gray-900 min-h-screen">
        {/* Header Navigation */}
        <div className="container mx-auto px-4 pt-8">
          <button
            onClick={handleBackHome}
            className="inline-flex items-center space-x-2 px-6 py-3 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors"
          >
            <ArrowLeft size={16} />
            <span>Back to Home</span>
          </button>
        </div>

        {/* Gallery Section */}
        <section className="container mx-auto px-4 py-16">
          {/* Title */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white">Our Work</h1>
            <p className="text-lg text-gray-400 max-w-3xl mx-auto">
              See the incredible transformations we deliver. From luxury sedans to SUVs, 
              every vehicle gets the premium treatment it deserves.
            </p>
          </div>

          {/* Gallery Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 max-w-6xl mx-auto mb-16">
            {displayImages.map((item) => (
              <div key={item.id} className="group cursor-pointer">
                <div className="relative aspect-[9/16] rounded-lg overflow-hidden bg-gray-800">
                  {item.type === 'video' ? (
                    <VideoThumbnail
                      videoUrl={item.url}
                      title={item.title}
                      description={item.description}
                      className="w-full h-full transition-transform duration-300 group-hover:scale-105"
                    />
                  ) : (
                    <img
                      src={item.url}
                      alt={item.alt || 'Car detailing work'}
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                      loading="lazy"
                    />
                  )}
                  
                  {/* Hover overlay */}
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300"></div>
                </div>
              </div>
            ))}
          </div>

        </section>

        {/* Booking Section */}
        <BookingWalkthrough />
      </main>
    </>
  );
};

export default GalleryPage;